import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { delay, finalize, retry } from 'rxjs/operators';
import { AppConfig } from 'src/app/helpers/app.config';
import { Consultant } from 'src/app/models/consultant.model';
import { Invitation, InvitationSearch } from 'src/app/models/invitation.model';
import { Pagination } from 'src/app/models/pagination.model';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { fromInvitationsSearch } from 'src/app/reducers/invitations-search.reducer';
import { fromInvitations } from 'src/app/reducers/invitations.reducer';
import { InvitationService } from 'src/app/services/invitation.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-massive-send',
  templateUrl: './massive-send.component.html',
  styleUrls: ['./massive-send.component.scss']
})
export class MassiveSendComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: string;

  HCC: number[] = [];
  officeId: number;
  currentInvitationSearch: InvitationSearch;

  consultant$: Observable<Consultant>;
  invitations$: Observable<Pagination<Invitation>>;
  invitationSearch$: Observable<InvitationSearch>;
  consultant: Consultant;

  totalInvited: number;
  totalInvitations: number;
  responseTimes: number[] = [];
  errorEmails: string[] = [];
  step: 'instructions'|'uploadProgress'|'uploadResume' = 'instructions';

  @ViewChild('massiveSendModal') massiveSendModal;

  constructor(
    private modal: NgbModal,
    private store: Store,
    public utilsService: UtilsService,
    private invitationService: InvitationService
  ) { }

  ngOnInit(): void {
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.invitationSearch$ = this.store.pipe(select(fromInvitationsSearch.selectInvitationsSearchState));
    this.store.pipe(select(fromInvitations.selectInvitationsState)).subscribe(invitations => {
      this.totalInvitations = invitations.total;
    });

    this.HCC = AppConfig.settings.OFFICES_WITH_PROJECTS.split(',').map(officeId => Number(officeId));

    // Nos suscribimos al consultor y invitatonSearch
    combineLatest([
      this.invitationSearch$,
      this.consultant$,
    ]).subscribe(([invitationSearch, consultant]) => {
      this.officeId = consultant.office.randstadOffice;
      this.currentInvitationSearch = invitationSearch;
      this.consultant = consultant;
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  onTabClose(event) {
    if (this.step !== 'instructions') {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  open() {
    this.step = 'instructions';
    this.totalInvited = 0;
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.massiveSendModal,
        { ariaLabelledBy: 'Envío-Masivo', centered: true, backdrop: 'static', keyboard: false, size: 'xl' }
      );
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        // this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  /**
   * Si tras leer las instrucciones acepta, se mostrará el spinner
   * Candidate ID ,Email, Documento, Nombre y Apellido, Periodo de búsqueda,Invitación ID
   *  Proceso, Jobtype, Tipo de Prueba (se checkea también en BACK), Enviados por mi oficina, mis tests, o todos.
   */
  confirm() {
    this.step = 'uploadProgress';

    const reportParams = {
      randstadCandidate: this.currentInvitationSearch.randstadCandidate,
      email: this.currentInvitationSearch.email,
      idCard: this.currentInvitationSearch.idCard,
      name: this.currentInvitationSearch.name,
      surname: this.currentInvitationSearch.surname,
      invitationId: this.currentInvitationSearch.invitationId,
      testId: this.currentInvitationSearch.testId,
      process: this.currentInvitationSearch.process,
      status: this.currentInvitationSearch.status,
      jobtype: this.currentInvitationSearch.jobtype,
      testModel: this.currentInvitationSearch.testModel,
      createdBy: this.currentInvitationSearch.createdBy,
      consultantOfficeId: this.consultant.office.id,
      consultantUniqueName: this.currentInvitationSearch.consultantUniqueName,
      period: this.currentInvitationSearch.period,
      clientId: this.consultant.client.id
    };

    // limpiamos parámetros
    const cleanReportParams = this.utilsService.cleanParams(reportParams);
    this.setCreateAsSequence(cleanReportParams, 0);
  }

  // Funcion recursiva
  setCreateAsSequence(params: any, index: number) {
    const requestStartDate = Date.now();

    // TODO: Se necesita processId en lugar de process, no deberian existir esas dos propiedades
    this.invitationService.massiveSend(params).pipe(
      // Segundo y tercer intento con retardo de 1000ms
      retry(2), delay(1000),
      finalize(() => {
        // if (index < elements.length - 1) {
        //   this.setCreateAsSequence(params, (index + 1));
        // }
      })
    ).subscribe(response => {
       // Esperamos a que nos devuelve valores.
      if (response) {
        if (response.executionStatus == 'finished') {
          this.totalInvited = this.totalInvitations;
          this.step = 'uploadResume';
          return;
        }
        // guardamos los elementos que devuelve
        this.totalInvited += response.invited;
        this.responseTimes.push(Math.round((Date.now() - requestStartDate) / 1000));
      }

      if (this.totalInvited < this.totalInvitations) {
        this.setCreateAsSequence(params, (index + 1));
      }
    }, error => {
      this.utilsService.toast('error', 'Unexpected');

      if (error.message.includes('Errores:')) {
        let literal = '';
        this.errorEmails = JSON.parse(error.message.split(':')[1]);
        this.errorEmails.forEach(email => {
          literal += email + '\n';
        });
        this.utilsService.toast('warning', 'CannotCreateCandidateMassiveError', true, literal);
      } else {
        this.utilsService.toast('error', 'CannotUploadCandidates');
      }
    }, () => {
      // Cerramos modal y ponemos la valor del spinner a falso, para mostrar las instrucciones
      // cada vez que se abre la modal
    }).add(() => {
      // comparamos los dos arrays para ver si tienen el mismo número de elementos
      if (this.totalInvited === this.totalInvitations) {
        setTimeout(() => {
          this.step = 'uploadResume';
        }, 1000);
      }
    });
  }

  uploadProgress(): number {
    return this.totalInvited * 100 / this.totalInvitations;
  }

  estimatedTime(): string {
    if (!this.responseTimes.length) {
      return this.utilsService.secondsToTime((this.totalInvitations - this.totalInvited) * 5);
    } else {
      // El tiempo estimado sera igual al promedio de los tiempos de respuesta multiplicado por el numero de llamadas restante
      return this.utilsService.secondsToTime(
        (this.totalInvitations - this.totalInvited) *
        (
          this.responseTimes.reduce((total, current) => total + current, 0) /
          (this.responseTimes.length * (AppConfig.settings.SIZE_ARRAY_IN_GROUP || 3))
        )
      );
    }
  }

}
